$.fn.FormStep = function(form_steps) {
  let self = this

  if (self.data('form-step')) {
    return self.data('form-step')
  }

  self.name = self.data('name')

  self.el = {
    next_button: self.find('.field__next'),
    prev_button: self.find('.field__previous'),
  }

  self.clicked_prev = function() {
    form_steps.previous_step()
  }

  self.clicked_next = function() {
    if (form_steps.form.get_options().steps.submit_steps) {
      if (self.el.next_button.hasClass('field__next--force')) {
        form_steps.next_step()
      } else {
        form_steps.form.submit()
      }
    } else {
      form_steps.next_step()
    }
  }

  return function() {
    self.el.next_button.on('click', self.clicked_next)
    self.el.prev_button.on('click', self.clicked_prev)
    self.data('form-step', self)
    return self
  }()
}

$.fn.FormSteps = function(_form) {
  let self = this

  if (self.data('form-steps')) {
    return self.data('form-steps')
  }

  self.form = _form
  self.current_index = self.data('step')
  self.highest_index = self.data('highest-step')
  self.steps = []
  self.max_step = 0
  self.is_popping = true

  self.el = {
    steps: self.find('.form-step'),
    wrapper: self.find('.form-steps__steps'),
    tabs: self.find('.form-tabs__item'),
  }

  self.get_previous_step = function() {
    if (self.steps[self.current_index - 2] != undefined) {
      return self.steps[self.current_index - 2]
    }
    return false
  }

  self.get_current_step = function() {
    return self.steps[self.current_index - 1]
  }

  self.get_step = function(step_index) {
    return self.steps[step_index - 1]
  }

  self.updated = function() {
    if (self.current_index > self.highest_index) {
      self.highest_index = self.current_index
      self.el.tabs.each(function() {
        if ($(this).data('index') <= self.highest_index) {
          $(this).prop('disabled', false).removeAttr('disabled')
        }
      })
    }
    self.find('input[name="steps_current"]').val(self.current_index)
    if (self.form.get_options().onStep != undefined) {
      self.form.get_options().onStep(self)
    }
    if (self.form.get_options().auto_scroll) {
      let auto_scroll_offset = self.form.get_options().auto_scroll_offset
      if (typeof auto_scroll_offset === 'function') {
        auto_scroll_offset = auto_scroll_offset()
      }
      let windowTarget = self.form.offset().top - auto_scroll_offset
      if ($(window).scrollTop() > windowTarget) {
        $('html, body').animate({
          scrollTop: windowTarget + 'px',
        }, 450)
      }
    }
    self.attr('data-step', self.current_index)
  }

  self.go_to_previous_step = function(new_step) {
    if (new_step <= self.highest_index) {
      self.go_to_step(new_step)
    }
  }

  self.set_initial_step = function(initial_step) {
    if (initial_step > 1) {
      self.get_step(1).prop('hidden', true)
      self.get_step(1).attr('aria-expanded', 'false')
      self.get_step(initial_step).prop('hidden', false)
      self.get_step(initial_step).attr('aria-expanded', 'true')
    }
  }

  self.go_to_step = function(new_step) {
    if (new_step != self.current_index) {
      let next_step = self.get_step(new_step)
      if (next_step) {
        self.el.wrapper.height(self.el.wrapper.height())
        let current_step = self.get_current_step(),
        current_step_height = current_step.height(),
        next_step_height = next_step.prop('hidden', false).height()
        next_step.prop('hidden', true)
        current_step.fadeOut(250, function() {
          self.get_current_step().prop('hidden', true).attr('aria-expanded', 'false')
          self.current_index = new_step
          self.attr('data-step', self.current_index)
          self.get_current_step().prop('hidden', false).attr('aria-expanded', 'true').fadeIn(250)
          self.el.wrapper.animate({
            height: next_step_height + 'px',
          }, 250, function() {
            self.el.wrapper.css('height', '')
          })
          self.updated()
        })
      }
    }
  }

  self.go_to_field = function(field) {
    let new_step = field.closest('.form-step').index() + 1
    if (new_step != self.get_current_step()) {
      self.go_to_step(new_step)
    }
  }

  self.previous_step = function() {
    let target_step = self.current_index - 1
    if (target_step < 1) {
      target_step = 1
    }
    self.go_to_step(target_step)
  }

  self.next_step = function() {
    let target_step = self.current_index + 1
    if (target_step > self.steps.length) {
      target_step = self.steps.length
    }
    self.go_to_step(target_step)
  }

  return function() {
    if (!self.current_index) {
      self.current_index = 1
    }
    if (!self.highest_index) {
      self.highest_index = 1
    }
    self.el.steps.each(function() {
      let step = $(this).FormStep(self)
      self.steps.push(step)
    })
    self.max_steps = self.steps.length
    self.el.tabs.each(function() {
      let target_step = $(this).data('index')
      $(this).on('click', function() {
        self.trigger('tab_click', [self.get_step(target_step)])
        self.go_to_step(target_step)
      })
    })
    if (self.form.get_options().steps.initial_step) {
      self.current_index = self.form.get_options().steps.initial_step
    }
    self.set_initial_step(self.current_index)
    self.updated()
    self.data('form-steps', self)
    return self
  }()
}
